import { useEffect, useState } from 'react';
import { getCdiAge } from '../../shared/institutionalAge.js';

function millisecondsToNextMinute() {
  return 60_000 - (Date.now() % 60_000) + 25;
}

export function useCdiAge() {
  const [age, setAge] = useState(() => getCdiAge());

  useEffect(() => {
    let timeout;
    const updateAndSchedule = () => {
      setAge(getCdiAge());
      timeout = window.setTimeout(updateAndSchedule, millisecondsToNextMinute());
    };
    const updateWhenVisible = () => {
      if (document.visibilityState === 'visible') setAge(getCdiAge());
    };

    timeout = window.setTimeout(updateAndSchedule, millisecondsToNextMinute());
    document.addEventListener('visibilitychange', updateWhenVisible);
    return () => {
      window.clearTimeout(timeout);
      document.removeEventListener('visibilitychange', updateWhenVisible);
    };
  }, []);

  return age;
}
